import { h } from 'preact'
import PropTypes from 'prop-types'
import TextArea from '../../Common/TextArea'
import { useTranslations } from '../../../hooks/useTranslations'
import { CARD_FIELDS } from '../../../constants/card'
import './styles.scss'

export default function PaymentNotes({ register }) {
  const l10n = useTranslations()

  return (
    <tui-payments-notes className="payment-notes mfe-component">
      <TextArea
        label={l10n.t('Payment notes')}
        inputProps={{
          'data-testid': 'payment-notes',
          maxLength: 256,
          ...register(CARD_FIELDS.notes),
        }}
      />
    </tui-payments-notes>
  )
}

PaymentNotes.propTypes = {
  register: PropTypes.func.isRequired,
}
